import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

export const StyledButton = withStyles({
    root: {
        width: '30%',
        '&:active': {
            boxShadow: 'none',
        },
    },
    containedPrimary: {
        color: 'white',
    },
})(props => <Button color="default" {...props} />);

export const StyledMainStepper = withStyles({
    root: {
        height: 80,
        margin: 0,
        marginTop: 0,
        padding: 0,
        width: '100%',
    },
})(props => <Stepper alternativeLabel nonLinear {...props} />);

export const StyledStep = withStyles({
    root: {},
})(props => <Step {...props} />);

export const StyledStepLabel = withStyles({
    root: {
        color: 'red',
    },
    '@media (max-width: 400px)': {
        labelContainer: {
            display: 'none',
        },
    },
})(props => <StepLabel {...props} />);
